import PropTypes from 'prop-types';
import Text from './Text';

const ErrorForSelect = ({ children, style, ...props }) => (
  <Text {...props} className="text-red-600" style={{ fontSize: 14, marginTop: '2vh', ...style }}>
    {children}
  </Text>
);

ErrorForSelect.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object
};

export default ErrorForSelect;
